import React from "react";

const Footer = () => {
	return (
		<div className='bg-gray-800 text-center p-12 absolute left-0 bottom-0 w-full '>
			Made By Rik
		</div>
	);
};

export default Footer;
